module.exports = __webpack_public_path__ + "914fd5af5a93508520602007a5a5bd12.svg";